import { render } from "./LayoutTwoThirds.vue?vue&type=template&id=c8a12b4e&scoped=true"
const script = {}

import "./LayoutTwoThirds.vue?vue&type=style&index=0&id=c8a12b4e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c8a12b4e"

export default script